export const EVENTS_READ = "events.read";
export const EVENTS_MANAGE = "events.manage";
export const EVENTS_OVERRIDE = "events.override";
export const EVENTS_SETTINGS = "events.settings";
export const DINING_READ = "events.dining.read";
export const DINING_MANAGE = "events.dining.manage";
